'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UIFieldset from 'UIComponents/form/UIFieldset';
import colr from './vendor/colr';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const modesMap = ['RGB', 'HSB', 'HSL'];
const ParamContainer = styled(UIFieldset).withConfig({
  displayName: "Params__ParamContainer",
  componentId: "sc-19xophv-0"
})(["margin-left:8px;width:115px;"]);
const ParamInputLabel = styled(props => {
  return /*#__PURE__*/_jsx(UIInputStaticLabel, Object.assign({
    "data-test-id": "colorpicker-param-input-label",
    labelWrapperClassName: "input-label-wrapper"
  }, props));
}).withConfig({
  displayName: "Params__ParamInputLabel",
  componentId: "sc-19xophv-1"
})(["display:block;&:not(:last-child){margin-bottom:8px;}& .input-label-wrapper{padding-left:10px;width:22px;}"]);
export default class Params extends Component {
  static getDerivedStateFromProps(props, state) {
    if (props.hex !== state.prevHex) {
      return {
        inputValue: props.hex.replace('#', ''),
        prevHex: props.hex
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.onHexHandler = evt => {
      const inputValue = evt.target.value.replace(/[^0-9a-f]/gi, '').slice(0, 6);
      this.setState({
        inputValue
      });
      if (inputValue.length < 6) return;
      try {
        const color = colr.fromHex(inputValue);
        this.props.onChange({
          hex: color.toHex()
        });
      } catch (e) {
        /* eslint no-empty:0 */
      }
    };
    this.onAlphaHandler = evt => {
      let alpha = parseInt(evt.target.value, 10);
      if (isNaN(alpha)) {
        alpha = 0;
      }
      alpha = Math.max(0, alpha);
      alpha = Math.min(alpha, 100);
      this.props.onChange({
        alpha
      });
    };
    this.onColorChannelChange = (index, evt) => {
      const value = this.getChannelInRange(evt.target.value, index);
      const colorChannel = this.getColorChannel();
      colorChannel[index] = value;
      const {
        hex,
        hue
      } = this.getColorByChannel(colorChannel);
      this.props.onChange({
        hex,
        hue
      });
    };
    this.getChannelInRange = (value, index) => {
      const channelMap = {
        RGB: [[0, 255], [0, 255], [0, 255]],
        HSB: [[0, 360], [0, 100], [0, 100]],
        HSL: [[0, 360], [0, 100], [0, 100]]
      };
      const mode = this.props.mode;
      const range = channelMap[mode][index];
      let result = parseInt(value, 10);
      if (isNaN(result)) {
        result = 0;
      }
      result = Math.max(range[0], result);
      result = Math.min(result, range[1]);
      return result;
    };
    this.getColorByChannel = colorChannel => {
      const {
        mode
      } = this.props;
      let hex;
      let hue;
      switch (mode) {
        case 'RGB':
          hex = colr.fromRgbArray(colorChannel).toHex();
          break;
        case 'HSB':
          hex = colr.fromHsvArray(colorChannel).toHex();
          hue = colorChannel[0];
          break;
        case 'HSL':
          hex = colr.fromHslArray(colorChannel).toHex();
          hue = colorChannel[0];
          break;
        default:
          hex = colr.fromRgbArray(colorChannel).toHex();
      }
      return {
        hex,
        hue
      };
    };
    this.getColorChannel = () => {
      const {
        hex,
        hue,
        mode
      } = this.props;
      const color = colr.fromHex(hex);
      let result;
      switch (mode) {
        case 'RGB':
          result = color.toRgbArray();
          break;
        case 'HSB':
          result = [hue, ...color.toHsvArray().slice(1)];
          break;
        case 'HSL':
          result = [hue, ...color.toHslArray().slice(1)];
          break;
        default:
          result = color.toRgbArray();
      }
      return result;
    };
    this.state = {
      inputValue: props.hex.replace('#', ''),
      prevHex: props.hex
    };
  }
  renderRgbaInput(colorChannelIndex) {
    const colorChannel = this.getColorChannel();
    const keyName = this.props.mode[colorChannelIndex];
    return /*#__PURE__*/_jsx(ParamInputLabel, {
      text: keyName,
      className: "private-react-colorpicker--param-input",
      children: /*#__PURE__*/_jsx(UINumberInput, {
        maxLength: "A",
        value: colorChannel[colorChannelIndex],
        onChange: this.onColorChannelChange.bind(null, colorChannelIndex)
      })
    }, keyName);
  }
  renderAlphaInput() {
    return /*#__PURE__*/_jsx(ParamInputLabel, {
      text: "A",
      className: "private-react-colorpicker--param-input",
      children: /*#__PURE__*/_jsx(UINumberInput, {
        value: this.props.alpha,
        onChange: this.onAlphaHandler
      })
    }, "A");
  }
  renderRgba() {
    const {
      hexOnly,
      includeAlpha
    } = this.props;
    let inputs = [];
    if (!hexOnly) {
      inputs = inputs.concat([this.renderRgbaInput(0), this.renderRgbaInput(1), this.renderRgbaInput(2)]);
    }
    if (includeAlpha) inputs.push(this.renderAlphaInput());
    return inputs;
  }
  render() {
    const {
      fieldsetSize
    } = this.props;
    return /*#__PURE__*/_jsxs(ParamContainer, {
      "data-test-id": "colorpicker-input-params",
      className: "private-react-colorpicker--params",
      _size: fieldsetSize,
      children: [this.renderRgba(), /*#__PURE__*/_jsx(ParamInputLabel, {
        text: "#",
        className: "private-react-colorpicker--param-input",
        children: /*#__PURE__*/_jsx(UITextInput, {
          maxLength: "7",
          onChange: this.onHexHandler,
          value: this.state.inputValue
        })
      })]
    });
  }
}
Params.propTypes = {
  onChange: PropTypes.func,
  alpha: PropTypes.number,
  fieldsetSize: UIFieldset.propTypes._size,
  hex: PropTypes.string.isRequired,
  hue: PropTypes.number.isRequired,
  hexOnly: PropTypes.bool,
  includeAlpha: PropTypes.bool,
  mode: PropTypes.oneOf(modesMap)
};
Params.defaultProps = {
  mode: modesMap[0]
};